module.exports = __webpack_public_path__ + "static/media/Img-onboarding-tokens-intro.f2cdf908.png";